import enumify from './enumify';

export const MAP = 'MAP';
export const UNMAP = 'UNMAP';

export default enumify({ MAP, UNMAP });
